import { uaIsIE11 } from './ua-sniffing';
import repaintPromise from './repaintPromise';

/**
 * Assorted scroll utility functions.
 *
 * @module 00-utilities/scroll-utils.js
 *
 * @author <Sergio Jiménez Herena> [sergio.jimenez@selectra.info]
 */

/**
 * Scroll the page to given coordinates.
 *
 * @param x {number}
 *   The pixel along the horizontal axis of the document that you want displayed
 *   in the upper left
 * @param y {number}
 *   the pixel along the vertical axis of the document that you want displayed
 *   in the upper left.
 * @param smooth {Boolean}
 *   If true, use smooth scrolling.
 */
function scrollToCoordinates( x, y, smooth = true ) {
  repaintPromise().catch(() => {
    if ( uaIsIE11()) {
      window.scrollTo( x, y );
    } else {
      window.scrollTo({
        top: y,
        left: x,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }
  });
}

export { scrollToCoordinates };
